import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import { ToastProvider } from "./components/ui/ToastModal";
import { BreadcrumbProvider } from "./hooks/useBreadcrumbContext";
import { AppLayout } from "./components/layout/AppLayout";
import { RoleGuard } from "./components/RoleGuard";
import { RoleProtectedWrapper } from "./components/RoleProtectedWrapper";
import { LoginPage } from "./pages/auth/Login";
import { CompleteSetupPage } from "./pages/auth/CompleteSetup";
import { Dashboard } from "./pages/Dashboard";
import { ProjectsPage } from "./pages/Projects";
import { NewProjectPage } from "./pages/NewProject";
import { ProjectDetailPage } from "./pages/ProjectDetail";
import { ActivityLogsPage } from "./pages/ActivityLogs";
import { PnlAnalyticsPage } from "./pages/PnlAnalytics";
import { SettingsPage } from "./pages/Settings";
import { TeamPage } from "./pages/Team";
import { OrgSettingsPage } from "./pages/OrgSettings";
import { BillingPage } from "./pages/Billing";
import { SuperAdminOrgsPage } from "./pages/SuperAdminOrgs";
import { XeroCallbackPage } from "./pages/auth/XeroCallback";
import "./index.css";

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <BreadcrumbProvider>
          <Routes>
            {/* Auth Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/complete-setup" element={<CompleteSetupPage />} />

            {/* Protected Routes */}
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/new" element={<NewProjectPage />} />
              <Route
                path="/projects/:projectId"
                element={<ProjectDetailPage />}
              />
              <Route path="/activity" element={<ActivityLogsPage />} />

              {/* SEQ-180: same in-place financial guard as the project P&L tab (RoleProtectedWrapper), not a redirect */}
              <Route
                path="/pnl-analytics"
                element={
                  <RoleProtectedWrapper>
                    <PnlAnalyticsPage />
                  </RoleProtectedWrapper>
                }
              />

              {/* Admin+ (super_admin & admin can manage team and org settings) */}
              <Route
                path="/team"
                element={
                  <RoleGuard requiredRole="admin">
                    <TeamPage />
                  </RoleGuard>
                }
              />
              <Route
                path="/org-settings"
                element={
                  <RoleGuard requiredRole="admin">
                    <OrgSettingsPage />
                  </RoleGuard>
                }
              />
              <Route
                path="/settings"
                element={
                  <RoleGuard requiredRole="admin">
                    <SettingsPage />
                  </RoleGuard>
                }
              />

              {/* Super Admin only (billing is the CEO's domain) */}
              <Route
                path="/billing"
                element={
                  <RoleGuard requiredRole="super_admin">
                    <BillingPage />
                  </RoleGuard>
                }
              />

              {/* Platform Admin Only (SEQ super admin) */}
              <Route
                path="/super-admin/orgs"
                element={
                  <RoleGuard requiredRole="platform_admin">
                    <SuperAdminOrgsPage />
                  </RoleGuard>
                }
              />
            </Route>

            {/* OAuth Callback Routes (outside AppLayout, full-page) */}
            <Route path="/settings/xero/callback" element={<XeroCallbackPage />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BreadcrumbProvider>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
